import * as constants from "../../constants";

const reportInitState = {
  counties: [],
  weatherMoratorium: [],
};

export function weatherMoratorium(state = reportInitState, action) {
  switch (action.type) {
    case constants.LIST_WEATHER_MORATORIUM_SUCCESS:
      return {
        ...state,
        weatherMoratorium: action.payload?.list || [],
      };
    case constants.LIST_TDSP_COUNTIES_SUCCESS:
      return {
        ...state,
        counties: action.payload?.list || [],
      };
    default:
      return state;
  }
}
